import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import { Text } from 'preact-i18n';

import store from '../../store';

import ServiceWrapper from './serviceWrapper'

export default  class aService extends Component {
	render() {
		return (<ServiceWrapper {...this.props}>
						<article class="has-widget">
							<p>Divi balss kanāli un iespēja aktivizēt neierobežotu skaitu telefona numuru, kas tiek nodrošināta, izmantojot interneta pieslēgumu un SIP (Session Initiation Protocol) pārraides protokolu. Pakalpojums ir savietojams ar visām populārākajām ISDN2 biroju telefonu centrālēm (Alcatel, Cisco, Panasonic, Siemens, Ericcson, Nortel, u.c.). Lai izmantotu pakalpojumu, uzņēmumā uzstādīto esošo centrāli nav nepieciešams mainīt vai konfigurēt.</p>
							<h2>Priekšrocības</h2>
							<ul>
								<li>Iespēja izmantot esošo telefona centrāli un tālruņus, nav jāpārbūvē esošā kabeļu infrastruktūŗa</li>
								<li>Tiešais optiskais pieslēgums nodrošina izcilu sarunu kvalitāti.</li>
								<li>Nodrošina pakāpeniskas pārejas iespēju uz IP telefoniju</li>
								<li>Zvanu ieraksta iespēja un droša ierakstu uzglabāšana (visi dati tiek glabāti 3 kopijās uz fizisiki neatkarīgām iekārtām)</li>
								<li>Datu centra un telefonijas infrastruktūras atbilstība GDPR datu aizsardzības regulai</li>
							</ul>
						</article>
						<div class="widget plan">
							<h3><span class="from"><Text id="cart.from"/></span><span class="value">€14</span><span class="term"> <Text id="cart.month.full"/></span></h3>
						     <ul class="bullet">
						     	<li>Bezmaksas ierīkošana</li>
						     	<li>10% atlaide maksājot par 12 mēnešiem</li>
						     </ul>
						     <div><Link href={store.prefix+'/contact?service=isdn&form=true'} class="button"><Text id="email.widget.list.btn"/></Link></div>
						</div>
				</ServiceWrapper>);
	}
}



// WEBPACK FOOTER //
// ./routes/services/isdn.js